/**
 * Calcul des loyers PEAC — Location Financière (sans valeur résiduelle)
 * Reproduit le calculateur PEAC « bon-loc-beauty-tech-10-2026.xlsx »,
 * conditions valables jusqu'au 31/12/2026.
 *
 * - Taux annuel selon le montant financé (tranches ci-dessous)
 * - Loyers terme à échoir, frais de dossier 1 % (base 101 %), option d'achat 1 %
 * - Avec premier loyer majoré (PLM) : 1 PLM + 47 ou 59 loyers suivants
 */

// Tranches de taux annuel selon le montant financé (HT)
const RATE_TIERS = [
  { min: 100000, rate: 0.10 },
  { min: 35000, rate: 0.105 },
  { min: 15000, rate: 0.11 },
  { min: 7500, rate: 0.115 },
  { min: 0, rate: 0.125 }
];

// Bornes du premier loyer majoré, en % du montant financé
export const PLM_MIN_RATIO = 0.04;
export const PLM_MAX_RATIO = 0.3;

const roundCents = (value) => Math.round(value * 100) / 100;

const getAnnualRate = (amount) => RATE_TIERS.find(tier => amount >= tier.min).rate;

/**
 * Équivalent de la fonction Excel PMT (VPM)
 */
const pmt = (rate, nper, pv, fv, type) => {
  const factor = Math.pow(1 + rate, nper);
  return -(pv * factor + fv) * rate / ((1 + rate * type) * (factor - 1));
};

/**
 * Calcule le loyer mensuel HT PEAC
 * @param {number} amount - Montant financé HT
 * @param {number} months - Durée totale (48 ou 60)
 * @param {number} firstPayment - Premier loyer majoré (0 si aucun)
 * @returns {number} Loyer mensuel au centime (ou loyers suivants si PLM)
 */
export const computePeacMonthly = (amount, months, firstPayment = 0) => {
  const monthlyRate = getAnnualRate(amount) / 12;
  if (firstPayment > 0) {
    // Capital restant après le PLM, capitalisé un mois, réparti sur les loyers suivants
    const remaining = (101 - 100 * firstPayment / amount) * (1 + monthlyRate);
    return roundCents(amount * pmt(monthlyRate, months - 1, -remaining, 1, 1) / 100);
  }
  return roundCents(amount * pmt(monthlyRate, months, -101, 1, 1) / 100);
};
